module.exports = __webpack_public_path__ + "img/HUT-MNC_REVISI-2.e182e756.jpg";